import type {
  DataCompletenessDetailsResponse,
  DataCompletenessSummaryResponse,
} from '@repo/contracts/tenant-api';
import { tenantApiRoutes } from '@repo/contracts/tenant-api';

import { tenantApi } from '@/redux/api/tenant-api';

export const dataCompletenessApi = tenantApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataCompletenessSummary: builder.query<
      DataCompletenessSummaryResponse | null,
      void
    >({
      query: () => tenantApiRoutes.dataCompleteness.summary(),
      providesTags: [{ type: 'Dashboard', id: 'DATA_COMPLETENESS' }],
    }),

    getDataCompletenessDetails: builder.query<
      DataCompletenessDetailsResponse,
      void
    >({
      query: () => tenantApiRoutes.dataCompleteness.details(),
      providesTags: [{ type: 'Dashboard', id: 'DATA_COMPLETENESS_DETAILS' }],
    }),

    getPermitConfigDataCompleteness: builder.query<
      DataCompletenessDetailsResponse & {
        completionPct: number;
        totalRequired: number;
        totalMissing: number;
      },
      { permitConfigName: string; submissionId?: string }
    >({
      query: ({ permitConfigName, submissionId }) =>
        tenantApiRoutes.dataCompleteness.details(
          permitConfigName,
          submissionId,
        ),
      providesTags: (_result, _err, { permitConfigName, submissionId }) => [
        {
          type: 'Dashboard',
          id: submissionId
            ? `DATA_COMPLETENESS_${permitConfigName}_${submissionId}`
            : `DATA_COMPLETENESS_${permitConfigName}`,
        },
      ],
    }),

    refreshDataCompleteness: builder.mutation<
      DataCompletenessSummaryResponse,
      void
    >({
      query: () => ({
        url: tenantApiRoutes.dataCompleteness.refresh(),
        method: 'POST',
      }),
      invalidatesTags: [
        { type: 'Dashboard', id: 'DATA_COMPLETENESS' },
        { type: 'Dashboard', id: 'DATA_COMPLETENESS_DETAILS' },
      ],
    }),
  }),
});

export const {
  useGetDataCompletenessSummaryQuery,
  useGetDataCompletenessDetailsQuery,
  useGetPermitConfigDataCompletenessQuery,
  useRefreshDataCompletenessMutation,
} = dataCompletenessApi;
